import { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

const baseInput =
  'w-full bg-neutral-900 border text-base text-white rounded-lg px-3 py-2 outline-none transition-colors placeholder:text-white/30';

const inputClass = (hasError: boolean) =>
  `${baseInput} ${hasError ? 'border-[#FF8A00]' : 'border-neutral-700 focus:border-green01'}`;

interface AuthInputProps {
  label: string;
  type?: 'text' | 'email' | 'password';
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  placeholder?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  name?: string;
}

export const AuthInput = ({
  label,
  type = 'text',
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder,
  autoComplete,
  autoFocus,
  name,
}: AuthInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const hasError = !!error;

  return (
    <div className="w-full flex flex-col">
      <label className="block text-xs text-white/70 mb-1">{label}</label>

      <div className="relative">
        <input
          type={isPassword ? (showPassword ? 'text' : 'password') : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          placeholder={placeholder}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          name={name}
          className={`${isPassword ? `${inputClass(hasError)} pr-10` : inputClass(hasError)} ${
            disabled ? 'text-greyP2 cursor-not-allowed' : ''
          }`}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1.5 text-white/50 hover:text-white/80 transition-colors"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>

      {(error || helperText) && (
        <p className={`text-xs mt-1 ml-0.5 ${hasError ? 'text-[#FF8A00]' : 'text-white/50'}`}>{error || helperText}</p>
      )}
    </div>
  );
};
